import React from 'react';
import '../Css/Navbar.css'
import resume from '../images/myResume.pdf'

const Navbar = () => {

    const menu = <>
    

    <li><a href="#about">ABOUT</a></li>
    <li><a href="#skill">SKILL</a></li>
    <li><a href="#portfolio">PORTFOLIO</a></li>
    <li><a href="#contact">CONTACT</a></li>
    <li><a href="#blog">BLOG</a></li>
    <li><a className='anchor-style' href={resume} download='myResume'>RESUME</a></li>
      
  
   
    </>
    return (
        <>
        <div class="flex justify-center items-center gap-x-96 lg:px-16 pt-10 pb-20 nav-section">
  <div class="flex gap-x-64 lg:gap-x-0">
    <div class="dropdown ">
      <label tabindex="0" class="btn btn-ghost lg:hidden">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-7 text-yellow-500 " fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
      </label>
      <ul tabindex="0" class="menu menu-compact dropdown-content mt-3 p-2 shadow bg-slate-800 rounded-box w-60">
       {menu}
      </ul>
    </div>
    <a class="btn btn-ghost normal-case header-title text-white text-2xl lg:text-4xl mask mask-hexagon lg:mr-40  "
    href="#">
      B</a>
  </div>
  <div class=" hidden lg:flex">
    <ul class="menu menu-horizontal p-0">
      {menu}
    </ul>
  </div>

</div>
        </>
    );
};

export default Navbar;